import Grid from '@mui/material/Grid';
import { Document, PDFViewer, Page, Text, View } from '@react-pdf/renderer';
import * as React from 'react';
import * as Redux from 'react-redux';
import { stylesDocPdf } from '../../../../pdfs';
import HeaderPdf from '../../../../pdfs/HeaderPdf';

const styles = {
  pdfViewer: {
    width: '100%',
    height: '80vh',
    zIndex: 50,
  },
  section: {
    flex: 1,
    ...stylesDocPdf.section,
    margin: '20pt',
  },
  celda: {
    border: '1px solid black',
    height: '31px',
    padding: '2px',
  },
};

function texto(text) {
  return (
    <Text
      style={{
        fontSize: '9pt',
        fontWeight: 'bold',
      }}
    >
      {text}
    </Text>
  );
}

function docenteCelda() {
  const wd = 45;
  const wdA = 45;

  return (
    <View>
      <View
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <View
          style={{
            ...styles.celda,
            width: `${wd}%`,
            borderRight: 'none',
            borderBottom: 'none',
          }}
        >
          {texto('Nombre y apellido:')}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${75 - wd}%`,
            borderRight: 'none',
            borderBottom: 'none',
          }}
        >
          {texto('Nro. identificación:')}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${75 - wd}%`,
            borderBottom: 'none',
          }}
        >
          {texto('Materia:')}
        </View>
      </View>
      <View
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          marginBottom: '5px',
        }}
      >
        <View
          style={{
            ...styles.celda,
            width: `${wdA}%`,
            borderRight: 'none',
          }}
        >
          {texto('Bloques pedagógico:')}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${80 - wdA}%`,
            borderRight: 'none',
          }}
        >
          {texto('Nivel académico:')}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${75 - wdA}%`,
            borderRight: 'none',
          }}
        >
          {texto('Sección:')}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${75 - wdA}%`,
          }}
        >
          {texto('Turno:')}
        </View>
      </View>
    </View>
  );
}
// function seccionCelda() {
//   return (
//     <View
//       style={{
//         width: '100%',
//         display: 'flex',
//         flexDirection: 'row',
//         marginBottom: '5px',
//       }}
//     >
//       <View
//         style={{
//           ...styles.celda,
//           width: '60.5%',
//           padding: '2px',
//           marginRight: '1px',
//           height: '20px',
//         }}
//       >
//         {texto('Nivel académico:')}
//       </View>
//       <View
//         style={{
//           ...styles.celda,
//           width: '20%',
//           padding: '2px',
//           height: '20px',
//           marginRight: '1px',
//         }}
//       >
//         {texto('Sección:')}
//       </View>
//       <View
//         style={{
//           ...styles.celda,
//           width: '20%',
//           padding: '2px',
//           height: '20px',
//         }}
//       >
//         {texto('Turno:')}
//       </View>
//     </View>
//   );
// }

function actividadCelda(id, index) {
  const wd = 75;
  return (
    <View
      style={{
        width: '50%',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <View
        style={{
          ...styles.celda,
          width: `${wd}%`,
          borderRight: 'none',
        }}
      >
        {texto(`Criterio ${index}:`)}
      </View>
      <View
        style={{
          ...styles.celda,
          width: `${100 - wd}%`,
          borderRight: 'none',
        }}
      >
        {texto(`Fecha:`)}
      </View>
      <View
        style={{
          ...styles.celda,
          width: `${90 - wd}%`,
          padding: '2px',
          borderRight: id === 0 ? 'none' : '1px solid black',
        }}
      >
        {texto('Pts.:')}
      </View>
    </View>
  );
}

function evaluacionCelda(index) {
  const wd = 84.5;
  return (
    <View>
      <View
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <View
          style={{
            width: `${90}%`,
            ...styles.celda,
            borderRight: 'none',
            borderBottom: 'none',
          }}
        >
          {texto(`Evaluación ${index}:`)}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${100 - wd}%`,
            padding: '2px',
            borderBottom: 'none',
          }}
        >
          {texto('Pts.:')}
        </View>
      </View>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-evelyn',
        }}
      >
        {actividadCelda(0, `${index}.1`)}
        {actividadCelda(1, `${index}.2`)}
      </View>
    </View>
  );
}

function temasCelda(index) {
  const wd = 65;
  return (
    <View
      style={{
        border: '1px solid black',
        marginBottom: '5px',
      }}
    >
      <View
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <View
          style={{
            ...styles.celda,
            width: `${72 - wd}%`,
            borderRight: 'none',
            borderBottom: 'none',
          }}
        >
          {texto('Nro.:')}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${wd}%`,
            borderRight: 'none',
            borderBottom: 'none',
          }}
        >
          {texto('Tema:')}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${80 - wd}%`,
            borderRight: 'none',
            borderBottom: 'none',
          }}
        >
          {texto('Desde:')}
        </View>
        <View
          style={{
            ...styles.celda,
            width: `${80 - wd}%`,
            borderBottom: 'none',
          }}
        >
          {texto('Hasta')}
        </View>
      </View>
      {evaluacionCelda(index)}
    </View>
  );
}

// Create Document Component
const PlantillaPdfPlanEvaluacion = () => {
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <PDFViewer style={styles.pdfViewer} showToolbar={true}>
          <Document
            title={`Plantilla de Plan de Evaluación`}
            onRender={() => {}}
          >
            <Page size="A4" style={stylesDocPdf.page}>
              <View style={styles.section}>
                <HeaderPdf entidad={entidadesStore.activo} />
                <View
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '10px',
                  }}
                >
                  <Text style={{ fontSize: '10pt' }}>
                    Formato para el Plan de Evaluación
                  </Text>
                </View>
                {docenteCelda()}
                {/* {seccionCelda()} */}
                {temasCelda(1)}
                {temasCelda(2)}
                {temasCelda(3)}
                {temasCelda(4)}
                {temasCelda(5)}
                {temasCelda(6)}
                <View
                  style={{
                    ...styles.celda,
                    width: '100%',
                    height: '60px',
                    padding: '5px',
                  }}
                >
                  <Text style={{ fontSize: '10pt' }}>Observación:</Text>
                </View>
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </Grid>
    </Grid>
  );
};

export default PlantillaPdfPlanEvaluacion;
